// extracted by mini-css-extract-plugin
export var menuIcon = "_ty-0";
export var menuIconInline = "_ty-1";